/**
 *
 * Asynchronously loads the component for SMS Module
 *
 */

import loadable from "core/components/loadable";

export default loadable(() => import("./index"));
